import ModelUtil from '@leverege/model-util'

import HoursRange from './HoursRange.js'

const TYPE = 'imagine.operatingHours.daily'

function create( options ) {
  const opts = options || {}

  return {
    type : TYPE,
    name : opts.name || null,
    open : opts.open != null ? opts.open : true,
    ranges : opts.ranges || [
      HoursRange.create()
    ]
  }
}

export default {
  TYPE,
  create,
  ...ModelUtil.createAllValue( 'name' ),
  ...ModelUtil.createAllValue( 'open' ),
  ...ModelUtil.createAllArray( 'ranges' )
}
